// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.date-form-control::after {
  content: unset !important;
}

.filterBtn {
  margin: 0px 5px;
}

.mat-form-field {
  width: 100%;
}

::ng-deep .mat-header-row {
  height: 56px !important;
  white-space: nowrap;
}

::ng-deep .mat-row {
  height: 64px !important;
}

::ng-deep .mat-cell,
::ng-deep .mat-header-cell {
  padding: 12px 16px !important;
  vertical-align: middle !important;
  line-height: 1.5 !important;
}

h2 {
  margin: 0;
  font-weight: 600;
  color: #1c1c1c;
  font-family: "Roboto", sans-serif !important;
}

.no-data-row {
  height: auto !important;
}

.no-data-cell {
  text-align: center;
  padding: 40px 16px !important;
}

.no-data-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: #9e9e9e;
}

.no-data-container mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  color: #bdbdbd;
}

.no-data-container p {
  margin: 0;
  font-size: 14px;
  font-family: "Roboto", sans-serif;
}

.resend-btn {
  white-space: nowrap !important;
}

.resend-btn ::ng-deep .mdc-button__label {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 12px !important;
}

.resend-btn mat-progress-spinner {
  display: inline-block !important;
  position: relative !important;
  top: -1px !important;
  margin-left: 8px;
}

.white-spinner ::ng-deep circle {
  stroke: white !important;
}

/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/careplus/careplus-agency-orders/careplus-agency-orders.component.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,6BAA6B;EAC7B,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,ghGAAghG","sourcesContent":[".date-form-control::after {\n  content: unset !important;\n}\n\n.filterBtn {\n  margin: 0px 5px;\n}\n\n.mat-form-field {\n  width: 100%;\n}\n\n::ng-deep .mat-header-row {\n  height: 56px !important;\n  white-space: nowrap;\n}\n\n::ng-deep .mat-row {\n  height: 64px !important;\n}\n\n::ng-deep .mat-cell,\n::ng-deep .mat-header-cell {\n  padding: 12px 16px !important;\n  vertical-align: middle !important;\n  line-height: 1.5 !important;\n}\n\nh2 {\n  margin: 0;\n  font-weight: 600;\n  color: #1c1c1c;\n  font-family: \"Roboto\", sans-serif !important;\n}\n\n.no-data-row {\n  height: auto !important;\n}\n\n.no-data-cell {\n  text-align: center;\n  padding: 40px 16px !important;\n}\n\n.no-data-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  color: #9e9e9e;\n}\n\n.no-data-container mat-icon {\n  font-size: 48px;\n  width: 48px;\n  height: 48px;\n  color: #bdbdbd;\n}\n\n.no-data-container p {\n  margin: 0;\n  font-size: 14px;\n  font-family: \"Roboto\", sans-serif;\n}\n\n.resend-btn {\n  white-space: nowrap !important;\n}\n\n.resend-btn ::ng-deep .mdc-button__label {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  gap: 12px !important;\n}\n\n.resend-btn mat-progress-spinner {\n  display: inline-block !important;\n  position: relative !important;\n  top: -1px !important;\n  margin-left: 8px;\n}\n\n.white-spinner ::ng-deep circle {\n  stroke: white !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
